interface AccommodationsPageProps {
  rpId: string;
}

export function AccommodationsPage({ rpId }: AccommodationsPageProps) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '1200px',
        overflowX: 'hidden',
        overflowY: 'auto',
      }}
    >
      <div style={{ maxWidth: '900px', height: '100%', margin: '0 auto' }}>
        <iframe
          className="airtable-embed"
          src={`https://airtable.com/embed/appt6JcME9skQkayn/pagmc56Hw3h1hgmd3/form?prefill_RPID=${rpId}&hide_RPID=true`}
          width="100%"
          height="1100px"
          style={{ background: 'transparent', border: 'none', maxWidth: '900px' }}
          title="Airtable Form"
        />
      </div>
    </div>
  );
}

export default AccommodationsPage;
